/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORTS : CHECK : STYLES --------------- ++++++++++ */
export default theme =>({
    check:{
      '& .singleselectdropdown': { 
        zIndex: 9,
        width: '100%'
      },
      '& .griditem': {
          maxWidth: pxToEm(310),
          width: '100%',
          marginRight: pxToEm(30),
          marginTop: pxToEm(20),
          '& .field':{
              maxWidth: pxToEm(310),
              width: '100%'
          }
      }
    }
});
